import loadSessionsLogic from "./loadSessionsLogic";
import loadSessionsFailLogic from "./loadSessionsFailLogic";

export default [...loadSessionsLogic, ...loadSessionsFailLogic];
